import './css/styles.css';

import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from "react-router-dom";

import React from 'react';

// Import Pages
import Home from "./pages/Home";
import Projects from './pages/Projects';

const Layout = () => {
  return (
    <>
      <Outlet/>
    </>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout/>,
    children: [
      {
        path: "/",
        element: <Home/>
      },
      {
        path: "/projects",
        element: <Projects/>
      }
    ]
  }
])

function App() {
  return (
    <div className="bg-teal-50">
      <div className='w-full h-screen font-serif'>
        <RouterProvider router={router}/>
      </div>
    </div>
  );
}

export default App;
